import { FLAGS_PARAM_NAME, LDFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'

/** Real LaunchDarkly flags only. Mocked data lives in `DevMocksContext`, not here. */
export const readDevFlagOverrides = (): Partial<LDFlags> => {
  try {
    const stored = localStorage.getItem(FLAGS_PARAM_NAME)
    return stored ? JSON.parse(stored) : {}
  } catch {
    return {}
  }
}

/** Keys set to `undefined` are removed, handing control back to LaunchDarkly. */
export const writeDevFlagOverrides = (overrides: Partial<LDFlags>) => {
  const merged: Record<string, unknown> = { ...readDevFlagOverrides(), ...overrides }
  Object.keys(merged).forEach((key) => merged[key] === undefined && delete merged[key])

  if (Object.keys(merged).length === 0) {
    localStorage.removeItem(FLAGS_PARAM_NAME)
    return
  }
  localStorage.setItem(FLAGS_PARAM_NAME, JSON.stringify(merged))
}

export const clearDevFlagOverrides = () => localStorage.removeItem(FLAGS_PARAM_NAME)
